import React from "react";

import { Stack, SvgIconProps } from "@mui/material";
import { House, PeopleAlt, Place } from "@mui/icons-material";

import { MiniStatBox } from "@/components/atoms";
import { AudienceSummary } from "@/types";
import { abbreviateNumber } from "@/utils";

interface AudienceMiniStatsProps {
  audienceSize: AudienceSummary;
  size?: "small" | "medium";
  color?: SvgIconProps["color"];
}

export const AudienceMiniStats: React.FC<AudienceMiniStatsProps> = ({
  audienceSize,
  size = "medium",
  color = "secondary",
}) => {
  return (
    <Stack direction="row" spacing={size === "small" ? 1 : 2}>
      {audienceSize.num_postcodes !== undefined && (
        <MiniStatBox
          name="Postcodes"
          value={audienceSize.num_postcodes}
          valueFormatter={abbreviateNumber}
          icon={<Place fontSize="small" color={color} />}
          size={size}
        />
      )}
      {audienceSize.num_sectors !== undefined && (
        <MiniStatBox
          name="Sectors"
          value={audienceSize.num_sectors}
          valueFormatter={abbreviateNumber}
          icon={<Place fontSize="small" color={color} />}
          size={size}
        />
      )}
      <MiniStatBox
        name="Households"
        value={audienceSize.num_households}
        valueFormatter={abbreviateNumber}
        icon={<House fontSize="small" color={color} />}
        size={size}
      />
      <MiniStatBox
        name="Audience Size"
        value={audienceSize.population_count}
        valueFormatter={abbreviateNumber}
        icon={<PeopleAlt fontSize="small" color={color} />}
        size={size}
      />
    </Stack>
  );
};

export default AudienceMiniStats;
